module.exports = __webpack_public_path__ + "58d410a2eb3aca8788b315ed111e01f0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ir.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ir.svg
// module chunks = 0